import { render, staticRenderFns } from "./DeliveryView.vue?vue&type=template&id=7b475bd6&scoped=true&"
import script from "./DeliveryView.vue?vue&type=script&lang=js&"
export * from "./DeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryView.vue?vue&type=style&index=0&id=7b475bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b475bd6",
  null
  
)

export default component.exports